module.exports = __webpack_public_path__ + "img/cintes-personalitzades.a082f211.jpg";